export default __webpack_public_path__ + "static/media/remaining-call.c85433ff.svg";